import {APP_INITIALIZER, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {NavbarComponent} from './navbar/navbar.component';
import {SharedModule} from '../shared/shared.module';
import {RouterModule} from '@angular/router';
import {HTTP_INTERCEPTORS, HttpClient, HttpHeaders} from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';
import {JWTInterceptor} from './jwt.interceptor';
import {UnauthorizedInterceptor} from './unauthorized.interceptor';
import {environment} from '../../environments/environment';
import {catchError, tap} from 'rxjs/operators';
import {EMPTY} from 'rxjs';
import {LandingComponent} from './landing/landing.component';
import {SidenavComponent} from './sidenav/sidenav.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {ForceChangePasswordComponent} from './force-change-password/force-change-password.component';
import {ChangePasswordCommonComponent} from './change-password-common/change-password-common.component';
import {HelpdeskTicketComponent} from './helpdesk-ticket/helpdesk-ticket.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {EditModalLayoutModule} from '../shared/edit-modal-layout/edit-modal-layout.module';
import {ListViewModule} from '../shared/list-view/list-view.module';
import {WidgetsModule} from '../shared/widgets/widgets.module';
import {PermissionsToolComponent} from '../shared/tools/permissions-tool/permissions-tool.component';
import {SettingsComponent} from './settings/settings.component';
import {HttpCancelService} from './httpcancel.service';
import {ManageHttpInterceptor} from './managehttp.interceptor';
import {AuthenticationService} from './authentication.service';
import {TimezonesService} from './timezones.service';
import {SwitchLanguageComponent} from "./switch-language/switch-language.component";

@NgModule({
  declarations: [
    LoginComponent,
    ResetPasswordComponent,
    SwitchLanguageComponent,
    NavbarComponent,
    LandingComponent,
    SidenavComponent,
    ChangePasswordCommonComponent,
    ForceChangePasswordComponent,
    HelpdeskTicketComponent,
    SettingsComponent,
    PermissionsToolComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    TranslateModule,
    MatExpansionModule,
    EditModalLayoutModule,
    ListViewModule,
    WidgetsModule,
  ],
  exports: [
    NavbarComponent,
    SidenavComponent,
    ChangePasswordCommonComponent,
  ],
  providers: [
     HttpCancelService,
    { provide: HTTP_INTERCEPTORS, useClass: ManageHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (http: HttpClient , authService: AuthenticationService , timezonesService : TimezonesService) => () => {
        if (window.location.href.includes('/public-form') || window.location.href.includes('/job-offer')) {
          return null;
        }
        const token = localStorage.getItem('authToken');
        const user = localStorage.getItem('currentUser');
        timezonesService.getTimezones();

        // If no token, mark auth as initialized immediately
        if (!token) {
          authService.markAuthAsInitialized();
          return Promise.resolve();
        }

        if (token && !user && window.location.href.includes('/viba/agent/agent-live')) {
          const options = {
            headers: new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('authToken')).set('Content-Type', 'application/json').set('accept', '*/*')
          };
          return http
            .post(
              `${environment.apiUrl}authenticate-agent`,options)
            .pipe(
              tap(userProfile => {
                // @ts-ignore
                userProfile.token = localStorage.getItem('authToken')
                localStorage.setItem('isLoggedIn', String(true))
                authService.setSessionParams(userProfile, true);
              }),
              catchError(() => EMPTY),
              tap(() => {
                // Mark authentication as initialized regardless of success/failure
                authService.markAuthAsInitialized();
              })
            )
            .toPromise();
        }
        return http
          .get(
            `${environment.apiUrl}re-authenticate`,
            { responseType: 'text' },
          )
          .pipe(
            tap(token => {

              localStorage.setItem('authToken', token);
              //if user has selected an org, mark the user logged in
              const selectedOrganization = localStorage.getItem('selectedOrganization');
              if(selectedOrganization) {
                localStorage.setItem('isLoggedIn', String(true));
              }
            }),
            catchError(() => EMPTY),
            tap(() => {
              // Mark authentication as initialized regardless of success/failure
              authService.markAuthAsInitialized();
            })
          )
          .toPromise();
      },
      multi: true,
      deps: [HttpClient,AuthenticationService,TimezonesService],
    },
    DeviceDetectorService,
  ],
})
export class CoreModule {
}
